import { v4 as uuidv4 } from 'uuid';
import { FlexLayoutRow } from '../../../../vtex-apps/flex-layout/FlexLayout/default';
import { ListContextRenderer } from '../../../../vtex-apps/list-context/ListContextRenderer/default';
import { StoreImageList } from '../../../../vtex-apps/store-image-list/StoreImageList/default';
import { VisibilityLayout } from '../../../../vtex-apps/VisibilityLayout/default';

export default function BannerSectionGroup() {
	return {
		componentName: 'VisibilityLayout',
		componentId: uuidv4(),
		componentGroup: 'BannerSectionGroup',
		variables,
		props: VisibilityLayout({ mzTitle: 'MZ | Seção de Banners (On/Off)' }).props,
		childrenComponents: [
			FlexLayoutRow(
				{ blockClass: 'bsg-4__flex-row', marginTop: 9, marginBottom: 9, mzTitle: 'MZ | Mosaico - Banners' },
				[
					StoreImageList(
						{
							preload: true,
							images: [
								{
									image: 'https://hefesto-upload-images.s3.amazonaws.com/1683045642921-sliderLayout-2-desktop.png',
									mobileImage:
										'https://hefesto-upload-images.s3.amazonaws.com/1683045718304-sliderLayout-2-mobile-2.png',
									description: 'Imagem',
								},
							],
						},
						[
							ListContextRenderer({
								listElement: 'div',
								itemElement: 'div',
								blockClass: 'bsg-4__flex-row',
							}),
						],
					),
				],
			),
		],
	};
}

const variables = [
	//background color
	{ type: 'color', list: [{ from: '--transparent', to: '--bsg-4-bg-color', name: 'Background' }] },
	{ type: 'borderRadius', list: [{ from: '--border-radius-none', to: '--bsg-4-img-border-radius', name: 'Image' }] },
];
